<div *ngrxLet="params$; let params;"
     class="bg-white border border-blue-40 border-solid"
     [style.width.px]="params?.eGridCell?.clientWidth > tabGroup?._elementRef?.nativeElement?.clientWidth ?
       params?.eGridCell?.clientWidth :
       tabGroup?._elementRef?.nativeElement?.clientWidth"
     [ngClass]="{ 'border-[#D62D1A]': editorFormGroup.invalid && editorFormGroup.touched }"
     cdkTrapFocus>
  <mat-tab-group #tabGroup
                 [disablePagination]="true"
                 class="min-w-fit">
    @for (medium of media; track medium) {
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon [svgIcon]="medium" class="w-4 h-4"></mat-icon>
        </ng-template>

        <form [formGroup]="editorFormGroup">
          <mat-form-field
              appearance="fill"
              class="textFormField">
          <textarea
              #textInput
              type="text"
              matInput
              appGxInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [placeholder]="getFullNameForFieldID(SocialMediaUrl[medium.toUpperCase()])"
              [formControlName]="SocialMediaUrl[medium.toUpperCase()]"></textarea>

            @if (textInput?.value?.length) {
              <div class="copyIcon"
                   (click)="copyTextInput(textInput)">
                <mat-icon svgIcon="content_copy"></mat-icon>
              </div>
            }
          </mat-form-field>
        </form>
      </mat-tab>
    }
  </mat-tab-group>
</div>

